angular.module('harriApp')
    .controller('EVerifyTestController', ['$scope', '$filter', 'hUser', '$stateParams', function ($scope, $filter, hUser, $stateParams) {
        $scope.brandId  = $stateParams.brand_id || hUser.getUserContext().brand_id;

        // $scope.validator.validation = {};

        var examId = -1;

        $scope.loading = true;

        var prevPassed = false;

        $scope.selectedQuestionIndex = 0;

        // Alerts types
        $scope.ALERT_TYPES = {};
        $scope.ALERT_TYPES.TEST_INACCESSIBLE = "USER_MUST_FINISH_THE_TRAINING";
        $scope.ALERT_TYPES.E_VERIFY_CERTIFIED = 2;
        $scope.ALERT_TYPES.PASS = "PASSED";
        $scope.ALERT_TYPES.FAIL = "FAILED";
        $scope.ALERT_TYPES.RETAKE_TEST = "RETAKE_TEST";
        $scope.ALERT_TYPES.PREV_PASS_SUCCESS = "PREV_PASS_SUCCESS";
        $scope.ALERT_TYPES.PREV_PASS_FAIL = "PREV_PASS_FAIL";

        // options states
        $scope.STATE = {};
        $scope.STATE.CORRECT = 1;
        $scope.STATE.INCORRECT = 2;
        $scope.STATE.NONE = 3;

        $scope.answerErrors = {
            "required": false,
        }


        $scope.clearAlerts = function () {
            delete $scope.alert;
        }

        var makeAlert = function (alertType) {

            var alert = {};

            switch (alertType) {
                case $scope.ALERT_TYPES.TEST_INACCESSIBLE:
                    alert.title = "Knowledge test inaccessible";
                    alert.text = "You must complete E-Verify training before you can take the knowledge test.";
                    break;
                case $scope.ALERT_TYPES.E_VERIFY_CERTIFIED:
                    alert.title = "E-Verify certified";
                    alert.text = "You must take E-Verify knowledge test and obtain a score of at least 70% before you are E-Verify certified.";
                    break;
                case $scope.ALERT_TYPES.PASS:
                    alert.title = "Congratulations!";
                    alert.text = "You have passed the E-Verify knowledge test and are now certified." + " <br/> " +
                        "You may now sign and verify the Employment Eligibility Form (I9).";
                    break;
                case $scope.ALERT_TYPES.FAIL:
                    alert.title = "Better luck next time!";
                    alert.text = "You did not receive the required score of 70% or above to pass, please repeat the E-Verify training and retake the knowledge test to be able to sign and verify the Employment Eligibility Form (I9).";
                    break;
                case $scope.ALERT_TYPES.RETAKE_TEST:
                    alert.title = "Retake Test";
                    alert.text = "You already took and passed the E-Verify knowledge test and have been certified. Feel free to go through the test again for your own knowledge.";
                    break;
                case $scope.ALERT_TYPES.PREV_PASS_SUCCESS:
                    alert.title = "Congratulations!";
                    alert.text = "You passed the E-Verify knowledge test!";
                    break;
                case $scope.ALERT_TYPES.PREV_PASS_FAIL:
                    alert.title = "Better luck next time!";
                    alert.text = "You did not receive the 70% needed to pass. Since you’ve already taken and passed the test, you are still E-Verify certified and can sign and verify the Employment Eligibility Form (I9).";
                    break;
            }
            alert.type = alertType;
            return alert;
        }

        $scope.getState = function (optionIndex) {
            var question = $scope.questions[$scope.selectedQuestionIndex];
            if (question.correctAnswer) {
                if (question.options[optionIndex].id === question.correctAnswer) {
                    return $scope.STATE.CORRECT;
                } else if (question.options[optionIndex].id === question.answer) {
                    return $scope.STATE.INCORRECT;
                }
            }

            return $scope.STATE.NONE;
        };

        $scope.isCorrectAnswer = function () {
            return $scope.questions[$scope.selectedQuestionIndex].answer ===
                    $scope.questions[$scope.selectedQuestionIndex].correctAnswer;
        };

        $scope.nextQuestion = function () {
            if ($scope.selectedQuestionIndex === $scope.questions.length - 1) {
                $scope.loading = true;

                OnBoardingAPI.finishExam($scope.brandId, examId, hUser.getUser().id)
                    .then(function (result) {
                        $scope.loading = false;

                        if (result.status === $scope.ALERT_TYPES.FAIL) {
                            if ( !prevPassed ) {
                                $scope.alert = makeAlert($scope.ALERT_TYPES.FAIL);
                            } else {
                                $scope.alert = makeAlert($scope.ALERT_TYPES.PREV_PASS_FAIL);
                            }

                        } else {
                            if ( !prevPassed ) {
                                $scope.alert = makeAlert($scope.ALERT_TYPES.PASS);
                            } else {
                                $scope.alert = makeAlert($scope.ALERT_TYPES.PREV_PASS_SUCCESS);
                            }
                        }
                        $scope.$digest()
                    });

            } else {
                $scope.selectedQuestionIndex++;
            }

        }

        $scope.submitQuestion = function () {

            if (!$scope.questions[$scope.selectedQuestionIndex].answer) {
                $scope.answerErrors.required = true;
                return;
            }

            $scope.answerErrors.required = false;

            $scope.loadingAnswer = true;

            try{
                $scope.$digest();
            } catch (e) {}

            OnBoardingAPI.answerQuestion(
                $scope.brandId,
                examId,
                $scope.questions[$scope.selectedQuestionIndex].id,
                [$scope.questions[$scope.selectedQuestionIndex].answer]
            ).then(function(answer) {
                    $scope.questions[$scope.selectedQuestionIndex].correctAnswer = answer.correct_option_ids[0];
                    $scope.loadingAnswer = false;
                    $scope.$digest();
                })
        };

        //init
        (function () {
            OnBoardingAPI.getExam($scope.brandId)
                .then(function (exam) {
                    examId = exam.id;
                    $scope.questions = exam.questions;

                    OnBoardingAPI.checkEVerifyExamStatus().then(function (data) {
                        if (data === $scope.ALERT_TYPES.PASS) {
                            prevPassed = true;
                            $scope.alert = makeAlert($scope.ALERT_TYPES.RETAKE_TEST);
                        } else {
                            $scope.alert = makeAlert($scope.ALERT_TYPES.E_VERIFY_CERTIFIED);
                        }

                        $scope.loading = false;
                        $scope.$digest();
                    }, function (err) {
                        $scope.alert = makeAlert($scope.ALERT_TYPES.E_VERIFY_CERTIFIED);
                        $scope.loading = false;
                        $scope.$digest();
                    });


                }, function (e) {
                    if (e.data.data === $scope.ALERT_TYPES.TEST_INACCESSIBLE) {
                        $scope.alert = makeAlert($scope.ALERT_TYPES.TEST_INACCESSIBLE);
                    }
                    $scope.loading = false;
                    $scope.$digest();
                });

        })();

    }]);
